<template>
    <div>
        <div class="page-wrap" v-show="showDel">
            <div class="l-part">
                <div class="top_wrap">
                    <div class="top-nav" @click="contNex('staysigned_count')">
                        <div class="top-label">待签合同</div>
                        <div class="top-val">{{ mainInfo.staysigned_count }}</div>
                    </div>
                    <div class="top-nav" @click="contNex('signed_count')">
                        <div class="top-label">已签合同</div>
                        <div class="top-val">{{ mainInfo.signed_count }}</div>
                    </div>
                    <div class="top-nav" @click="contNex('expired_count')">
                        <div class="top-label">即将到期合同</div>
                        <div class="top-val">{{ mainInfo.expired_count }}</div>
                    </div>
                    <div class="top-nav" @click="contNex('monthSigned_count')">
                        <div class="top-label">本月已签</div>
                        <div class="top-val">{{ mainInfo.monthSigned_count }}</div>
                    </div>
                    <div class="top-nav" @click="contNex('theweek_count')">
                        <div class="top-label">本周已签</div>
                        <div class="top-val">{{ mainInfo.theweek_count }}</div>
                    </div>
                    <div class="top-nav" @click="contDel('')">
                        <div class="top-label">已删除</div>
                        <div class="top-val">{{ mainInfo.count_del_num }}</div>
                    </div>
                    <div class="top-nav" @click="contNex('')">
                        <div class="top-label">已发起</div>
                        <div class="top-val">{{ mainInfo.contracts_total }}</div>
                    </div>
                </div>
                <div class="main-chart">
                    <div id="echarts" :style="{ width: '85%', height: '550px' }"></div>
                </div>
            </div>
            
            
            <div class="r-part">
                <!-- <div class="top-info">
                    <div class="info-title">账户信息<span @click="untying(userInfo.id)"
                            style=" cursor: pointer;color: #929394;font-size: 14px;font-weight: unset">（{{ userInfo.phone }}）</span>
                    </div>
                    <div class="b-num">
                        <div class="nav-i">
                            <div class="item-w"><span>{{ mainInfo.account_info.message_num || 0 }}</span>次</div>
                            <div class="item-s">短信总数</div>
                        </div> 
                        <div class="nav-i">
                            <div class="item-w"><span>{{ mainInfo.account_info.qr_code_num || 0 }}</span>次</div>
                            <div class="item-s">二维码总数</div>
                        </div>
                        <div class="nav-i">
                            <div class="item-w"><span>{{ mainInfo.account_info.not_contracts_num || 0 }}</span>次</div>
                            <div class="item-s">普通合同</div>
                        </div> 
                        <div class="nav-i" v-if="$store.state.identity == 2">
                            <div class="item-w"><span>{{ mainInfo.account_info.contracts_num || 0 }}</span>次</div>
                            <div class="item-s">认证合同</div>
                        </div>
                    </div>
                </div> -->
                <!-- 新账户信息 -->
                <div
                    class="account-card"
                    :class="{ 'account-card--has-bg': versionUserInfoLoaded }"
                    :style="accountCardStyle"
                >
                    <div class="account-card__head">
                        <div class="account-card__title">
                            账户信息<span class="account-card__phone">（{{ userInfo.phone || '—' }}）</span>
                        </div>
                        <div class="account-card__actions">
                            <button class="account-card__btn account-card__btn--renew" type="button" @click="openRenewModal">续费</button>
                            <button
                                v-if="canUpgrade"
                                class="account-card__btn account-card__btn--upgrade"
                                type="button"
                                @click="goVersionPackage"
                            >升级</button>
                        </div>
                    </div>
                    <div class="account-card__meta">
                        <span class="account-card__version">{{ accountVersionName }} {{ accountExpired ? '（已过期）' : '' }}</span>
                        <span class="account-card__expire">到期时间：{{ accountExpireText }}</span>
                    </div>
                    <div class="account-card__stats">
                        <div class="account-card__stat">
                            <div class="account-card__stat-val">
                                <span>{{ mainInfo.account_info.message_num || 0 }}</span>次
                            </div>
                            <div class="account-card__stat-label">短信总数</div>
                        </div>
                        <div class="account-card__stat">
                            <div class="account-card__stat-val">
                                <span>{{ mainInfo.account_info.qr_code_num || 0 }}</span>次
                            </div>
                            <div class="account-card__stat-label">二维码总数</div>
                        </div>
                        <div class="account-card__stat">
                            <!-- 大陆CA认证合同份数 -->
                            <div class="account-card__stat-val" v-if="$store.state.is_mainland == 1">
                                <span>{{ mainInfo.account_info.contracts_num || 0 }}</span>次
                            </div>
                            <!-- 非大陆CA普通合同份数 -->
                            <div class="account-card__stat-val" v-else>
                                <span>{{ mainInfo.account_info.not_contracts_num || 0 }}</span>次
                            </div>
                            <div class="account-card__stat-label">普通合同</div>
                        </div>
                        <div class="account-card__stat" v-if="$store.state.identity == 2">
                            <div class="account-card__stat-val">
                                <span>{{ mainInfo.account_info.contracts_num || 0 }}</span>次
                            </div>
                            <div class="account-card__stat-label">认证合同</div>
                        </div>
                    </div>
                </div>

                <div class="top-info" v-if="userInfo.role !== 3" style="margin-top: 20px;height: 240px">
                    <div class="info-title">用户信息</div>
                    <div class="i-know">
                        <div class="l-echarts">
                            <div id="circle" :style="{ width: '300px', height: '200px', left: '-25px' }"></div>
                        </div>
                        <div class="r-msg">
                            <div class="nav-wrap">
                                <div class="warp-label flex-c">普通用户</div>
                                <div class="warp-value">{{ mainInfo.account_info.ordinary_num }}人</div>
                            </div>
                            <div class="nav-wrap">
                                <div class="warp-label warp-two flex-c">副管理员</div>
                                <div class="warp-value">{{ mainInfo.account_info.deputy_num }}人</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="top-info" style="margin-top: 20px;height: 330px;position: relative">
                    <div class="info-title">待签署合同</div>
                    <div class="s-title">
                        <div class="num">{{ storePrams.total }}<span>份</span></div>
                        <div class="word">待办总量</div>
                    </div>
                    <div class="contract-list">
                        <div class="list-item flex-b" v-for="(item, index) in signList" :key="index">
                            <div style="align-items: center;display: flex">
                                <div class="l-tip flex-c">待签署</div>
                                <div class="con-mame">{{ item.contract_name }}</div>
                            </div>
                            <div class="con-icon" @click="seeDetail(item.id)"><i class="iconfont icon-chakan2"></i>
                            </div>
                        </div>
                    </div>
                    <div class="see-more" @click="goPage">查看更多</div>
                </div>
            </div>
        </div>
        <div>
            <detail ref="contractDel" @goBack="showSelf"></detail>
        </div>
        <Modal v-model="modal" title="解绑用户" @on-ok="ok" @on-cancel="cancel">
            <p>确定解绑嘛！！！</p>
        </Modal>
        <version-package-plans
            ref="versionPlans"
            modals-only
            :active="true"
            @paid="onVersionPaid"
        />
        <version-package-intro-modal
            :visible.sync="versionModalVisible"
            :version-user-info="versionUserInfo"
            @paid="onVersionPaid"
        />
    </div>
</template>

<script>
import { contractDetails, statistics, staySign, relieve, } from '../../api/interFace'
import detail from '../management/components/contractDel'
import VersionPackageIntroModal from '@/pages/versionPackage/components/IntroModal'
import VersionPackagePlans from '@/pages/versionPackage/components/Plans'
import { get_userinfo } from '@/api/versionPackage'
import {
    getAccountBg,
    formatVersionExpireTime,
    isPlatformExpired,
    getVersionNameByVersionId
} from '@/pages/versionPackage/accountCard'
import * as echarts from 'echarts';
// import {setCookies,removeCookies} from '@/utils/helper'
import { getCookies } from '@/utils/helper'

import config from '@/config/index'
export default {
    name: "index",
    components: { detail, VersionPackageIntroModal, VersionPackagePlans },
    data() {
        return {
            modal: false, 
            isIndependentDeployment: getCookies('is_independent_deployment') == 1 ? true : false || config.isIndependentDeployment,//是否为独立部署
            untyingId: "",
            topPart: [
                {
                    label: '',
                    val: ''
                }
            ],
            mainInfo: {
                account_info: {}
            },
            storePrams: {
                limit: 4,
                page: 1,
                total: 0
            },
            signList: [],
            showDel: true,
            versionModalVisible: false,
            versionUserInfo: null
        }
    },
    created() {
        
        this.$store.commit('changePollingSpin', true)
        this.getInfo()
        this.getVersionUserInfo()
        this.getList()
    },
    mounted() {
        this.initChat()
        if (this.userInfo.role !== 3) {
            this.initCircle()
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        accountInfo() {
            return this.mainInfo.account_info || {}
        },
        accountVersionName() {
            if (this.versionUserInfo && this.versionUserInfo.version_name) {
                return this.versionUserInfo.version_name
            }
            if (this.versionUserInfo && this.versionUserInfo.version_id != null) {
                return getVersionNameByVersionId(this.versionUserInfo.version_id) || '标准版'
            }
            return this.accountInfo.version_name
                || this.accountInfo.permissions_name
                || this.userInfo.version_name
                || this.userInfo.permissions_name
                || '标准版'
        },
        accountExpired() {
            if (this.versionUserInfo !== null) {
                return isPlatformExpired(this.versionUserInfo, getCookies('expires_time'))
            }
            return isPlatformExpired(this.accountInfo, getCookies('expires_time'))
        },
        versionUserInfoLoaded() {
            return this.versionUserInfo !== null
        },
        accountBg() {
            if (!this.versionUserInfoLoaded) return ''
            const versionId = this.versionUserInfo && this.versionUserInfo.version_id
            return getAccountBg(this.accountVersionName, this.accountExpired, versionId)
        },
        accountCardStyle() {
            if (!this.accountBg) return {}
            return { backgroundImage: `url(${this.accountBg})` }
        },
        accountExpireText() {
            if (this.versionUserInfo !== null) {
                return formatVersionExpireTime(this.versionUserInfo.version_expire_time)
            }
            if (Number(this.accountInfo.is_permanent) === 1) return '终身'
            const raw = this.accountInfo.expires_time
                || this.accountInfo.expire_time
                || getCookies('expires_time')
            return formatVersionExpireTime(raw)
        },
        canUpgrade() {
            const val = this.versionUserInfo && this.versionUserInfo.is_can_upgrade
            return val === true || val === 1 || val === '1'
        }
    },
    methods: {
        getExpiresTime(expiresTime) {
            let nowTimeNum = Math.round(new Date() / 1000)
            let expiresTimeNum = expiresTime - nowTimeNum
            return parseFloat(parseFloat(parseFloat(expiresTimeNum / 60) / 60) / 24)
        },
        contNex(e) {
            this.$router.push({ path: '/management/contract', query: { name: e } })
        },
        contDel(e){ 
            this.$router.push({ path: '/management/recyclebin', query: { name: e } })
        },
        untying(e) {
            this.$Modal.confirm({
                title: '解绑提示',
                content: '请问您是否确认解绑该用户！！！',
                onOk: () => {
                    relieve({ id: e }).then(res => {
                        this.$Message.success(res.msg)
                        this.getlist()
                    }).catch(res => {
                        this.$Message.error(res.msg)
                    })
                },
                onCancel: () => {
                }
            });
        },
        ok() {
            this.untyingId
            this.$Message.info('Clicked ok');
        },
        cancel() {
            // this.$Message.info('Clicked cancel');
        },
        getInfo() {
            statistics({ edition_type: 1 }).then(res => {
                this.mainInfo = res.data || {}
                this.mainInfo.account_info = res.data.account_info || {}
                let s = res.data.contract_statistics.notsigned_num
                let z = res.data.contract_statistics.signed_num
                let dateList = []
                let valList = []
                let secondVal = []
                if(this.isIndependentDeployment){
                    for (let i in s) {
                        dateList.push(i)
                        valList.push(s[i])
                    }               
                    for (let j in z) {
                        secondVal.push(z[j])
                    }
                }else {
                    s.forEach((item,index) => {                    
                        dateList.push(item.date)
                        valList.push(item.value)
                    });
                    z.forEach(item => {
                        secondVal.push(item.value)
                    });
                }               
                console.log('secondVal',secondVal)
                this.initChat(dateList, valList, secondVal)
                this.initCircle(res.data.account_info.deputy_num, res.data.account_info.ordinary_num)
            }).catch(res => {
                console.log(res)
            })
        },
        initChat(a, c, d) {
            var chartDom = document.getElementById('echarts');
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: a
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '未签合同',
                        type: 'line',
                        stack: 'no',
                        itemStyle: {
                            normal: {
                                color: '#0089E2',
                                lineStyle: {
                                    color: '#0089E2'
                                }
                            }
                        },
                        data: c
                    },
                    {
                        name: '已签合同',
                        type: 'line',
                        stack: 'yes',
                        itemStyle: {
                            normal: {
                                color: '#F77F54',
                                lineStyle: {
                                    color: '#F77F54'
                                }
                            }
                        },
                        data: d
                    },
                ]
            };
            myChart.setOption(option);
        }, 
        initCircle(a, b) {
            var chartDom = document.getElementById('circle');
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: '用户信息',
                        type: 'pie',
                        radius: ['40%', '75%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '22',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {
                                value: a,
                                name: '副管理员',
                                itemStyle: {
                                    normal: {
                                        color: '#F77F54',
                                    }
                                },
                            },
                            {
                                value: b,
                                name: '普通会员',
                                itemStyle: {
                                    normal: {
                                        color: '#4877E8',
                                    }
                                },
                            }
                        ]
                    }
                ]
            }
            myChart.setOption(option);
        },
        getList() {
            staySign(this.storePrams).then(res => {
                this.signList = res.data.data || []
                this.storePrams.total = res.data.total
            })
        },
        seeDetail(row) {
            const msg = this.$Message.loading({
                content: 'Loading...',
                duration: 0
            });
            contractDetails({ id: row, pcStatus: 1 }).then(res => {
                this.showDel = false
                this.$nextTick(() => {
                    this.$refs.contractDel.showDetail(res)
                })
                setTimeout(msg, 100);
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        showSelf() {
            this.showDel = true
        },
        goPage() {
            this.$router.push({ path: '/management/contract' })
        },
        openRenewModal() {
            const open = () => {
                if (this.$refs.versionPlans) {
                    this.$refs.versionPlans.openRenewByVersionId(this.versionUserInfo || {})
                }
            }
            if (this.versionUserInfo === null) {
                get_userinfo().then(res => {
                    this.versionUserInfo = res.data || {}
                    open()
                }).catch(() => open())
                return
            }
            open()
        },
        goVersionPackage() {
            get_userinfo().then(res => {
                this.versionUserInfo = res.data || {}
                this.versionModalVisible = true
            }).catch(() => {
                this.versionModalVisible = true
            })
        },
        getVersionUserInfo() {
            get_userinfo().then(res => {
                this.versionUserInfo = res.data || {}
            }).catch(() => {
                this.versionUserInfo = {}
            })
        },
        onVersionPaid() {
            this.getInfo()
            this.getVersionUserInfo()
        }
    }
}
</script>

<style scoped lang="scss">
.page-wrap {
    display: flex;
    justify-content: space-between;
    height: 60vh;

    .l-part {
        width: 69%;

        .top_wrap {
            width: 100%;
            height: 124px;
            background: #FFFFFF;
            border-radius: 8px;
            display: flex;

            .top-nav {
                flex: 1;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                &:not(:last-child) {
                    &:after {
                        position: absolute;
                        content: '';
                        display: inline-block;
                        width: 2px;
                        height: 56px;
                        background: #E4EAF9;
                        border-radius: 1px;
                        right: 0;
                    }
                }
                .top-label {
                    font-size: 18px;
                    font-weight: bold;
                    color: #191A1F;
                }
                .top-val {
                    font-size: 24px;
                    font-weight: bold;
                    color: #4877E8;
                }
            }
        }
        .main-chart {
            width: 100%;
            height: 650px;
            background: #FFFFFF;
            border-radius: 8px;
            margin-top: 20px;
            padding-left: 30px;
            padding-top: 40px;
            box-sizing: border-box;
        }
    }

    .r-part {
        width: 30%;

        .account-card {
            width: 100%;
            min-height: 182px;
            border-radius: 8px;
            padding: 20px 22px 18px;
            box-sizing: border-box;
            background: #fff;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            color: #191a1f;
            overflow: hidden;
        }

        .account-card--has-bg {
            color: #fff;
        }

        .account-card__head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
        }

        .account-card__title {
            font-size: 16px;
            font-weight: 700;
            line-height: 1.4;
        }

        .account-card__phone {
            font-size: 14px;
            font-weight: 400;
            opacity: 0.92;
        }

        .account-card__actions {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .account-card__btn {
            min-width: 56px;
            height: 28px;
            padding: 0 16px;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
            line-height: 28px;
            box-sizing: border-box;
            transition: opacity 0.2s;

            &:hover {
                opacity: 0.92;
            }
        }

        .account-card__btn--renew {
            border: 1px solid #4877e8;
            background: transparent;
            color: #4877e8;
        }

        .account-card__btn--upgrade {
            border: 1px solid #4877e8;
            background: #4877e8;
            color: #fff;
        }

        .account-card--has-bg .account-card__btn--renew {
            border-color: #fff;
            background: transparent;
            color: #fff;
        }

        .account-card--has-bg .account-card__btn--upgrade {
            border-color: #fff;
            background: #fff;
            color: #545f78;
        }

        .account-card__meta {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 12px;
            margin-top: 10px;
            font-size: 13px;
            opacity: 0.95;
        }

        .account-card__version {
            font-weight: 600;
        }

        .account-card__stats {
            display: flex;
            justify-content: space-between;
            margin-top: 28px;
            gap: 8px;
        }

        .account-card__stat {
            flex: 1;
            text-align: center;
        }

        .account-card__stat-val {
            font-size: 13px;
            margin-bottom: 6px;

            span {
                font-size: 22px;
                font-weight: 700;
                margin-right: 2px;
            }
        }

        .account-card__stat-label {
            font-size: 12px;
            opacity: 0.9;
        }

        .top-info {
            width: 100%;
            height: 182px;
            background: #FFFFFF;
            border-radius: 8px;
            padding: 24px 34px;
            box-sizing: border-box;
            .info-title {
                font-size: 16px;
                font-weight: bold;
                color: #191A1F;
            }
            .see-more {
                position: absolute;
                right: 20px;
                bottom: 2px;
                font-size: 16px;
                color: #1a9aef;
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
            }
            .b-num {
                display: flex;
                margin-top: 50px;
                justify-content: space-around;
                .nav-i {
                    font-size: 14px;
                    color: #929394;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    span {
                        font-size: 18px;
                        font-weight: bold;
                        color: #4877E8;
                    }
                }
            }
            .i-know {
                display: flex;
                align-items: center;
                position: relative;
            }

            .r-msg {
                position: absolute;
                left: 240px;
                top: 40px;
            }

            .nav-wrap {
                display: flex;
                align-items: center;
                margin-left: 12px;
                margin-top: 16px;
                .warp-label {
                    font-size: 17px;
                    color: #191A1F;
                    &:before {
                        display: inline-block;
                        content: '';
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        background: #1a9aef;
                        margin-right: 5px;
                    }
                }
                .warp-two {
                    &:before {
                        background: #F77F54;
                    }
                }
                .warp-value {
                    font-size: 16px;
                    color: #191A1F;
                    opacity: 0.6;
                    margin-left: 20px;
                }
            }
        }

        .s-title {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .num {
                font-size: 24px;
                font-weight: bold;
                color: #4877E8;

                span {
                    font-weight: unset;
                    height: 16px;
                    font-size: 16px;
                    color: #545F78;
                    margin-left: 3px;
                }
            }
            .word {
                font-size: 16px;
                font-weight: bold;
                color: #545F78;
            }
        }

        .contract-list { 
            .list-item {
                margin-top: 12px;
                .l-tip {
                    width: 58px;
                    height: 26px;
                    background: #EDF0F9;
                    border: 1px solid #E3E7F4;
                    border-radius: 4px;
                    font-size: 11px;
                    color: #545F78;
                    margin-right: 12px;
                }
                .con-icon {
                    .iconfont {
                        font-size: 24px;
                        cursor: pointer;

                        &:hover {
                            color: #1a9aef;
                        }
                    }
                }
            }
        }
    }
}
</style>
